import { useEffect, useState } from "react";
import axios from "axios";

export const SavedNotes = () => {
  const UserID = window.localStorage.getItem("UserID");
  const [post, setPost] = useState([]);
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const post = await axios.get(
          `https://blogapi21.onrender.com/posts/saves/${UserID}`
        );
        setPost(post.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchPosts();
  });

  return (
    <>
      <div className="flex flex-col justify-center align-middle items-center">
        <h1 className="mb-10 text-5xl">Saved Posts</h1>
        <ul className="flex justify-center">
          {post.map((post) => (
            <li
              key={post._id}
              className="border w-[90%] border-primary rounded-2xl overflow-hidden p-9 flex flex-col justify-center text-center"
            >
              <div className="flex justify-center pb-4">
                <h2 className="text-2xl">{post.title}</h2>
              </div>
              <div className="border w-[85%] border-secondary rounded-2xl overflow-hidden p-3 mx-auto text-left">
                <p>{post.content}</p>
              </div>
              <div className="mt-9 mb-3">
                <p className="text-xs">Posted by: {post.username}</p>
                <p className="text-xs">Posted on: {post.datetime}</p>
              </div>
              {post.image ? (
                <div className="m-auto">
                  <img src={post.image} alt="post" />
                </div>
              ) : null}
              {post.tag.length > 0 ? (
                <div className="m-auto mt-4">
                  <p>Tags:</p>
                  {post.tag.map((tag) => (
                    <div
                      key={tag}
                      className="badge badge-accent badge-outline border-2 rounded-lg p-3 mt-2 mx-1"
                    >
                      {tag}
                    </div>
                  ))}
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
